export default __webpack_public_path__ + "static/media/photography.3810fd6b.png";